import PerfectScrollbar from 'perfect-scrollbar'

import room from "BASE/components/chat/chat.base.component.room"

export default {
    props: {
        prop_classification: Object,
        prop_is_fold_out: Boolean,
    },
    components: {
        room,
    },
    data: function () {
        return {
            isFoldOut: this.prop_is_fold_out,
        };
    },
    methods: {
        foldList: function () {
            this.isFoldOut = !this.isFoldOut;
        },
    },
    computed: {
        title: function () {
            return this.prop_classification.name;
        },
        rooms: function () {
            return this.prop_classification.rooms;
        },
        totalCount: function () {
            return this.prop_classification.rooms.length;
        },
    },
    mounted: function () {
        if(this.$refs && this.$refs.scroll){
            new PerfectScrollbar(this.$refs.scroll, {wheelPropagation: false});
        }
    }
};
